export default __webpack_public_path__ + "media/img_01/1000@2x-18b8bbd7.jpg";